import CheckIcon from '@mui/icons-material/Check'
import {Box} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'

type Props = {
  hasSalesImpact?: boolean
}

export const SalesImpactLabel = ({hasSalesImpact}: Props) => {
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)

  if (hasSalesImpact) {
    return (
      <Box component="span" display="flex" alignContent="center">
        <CheckIcon sx={{fontSize: 16, color: (theme) => theme.palette.primary.main}} />
        {t('salesImpact.label.yes')}
      </Box>
    )
  }

  return <>{t('salesImpact.label.no')}</>
}
